/* eslint-disable */
export default {
  copyToClipboard: 'Copiar para a área de transferência',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
